import * as React from "react";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import { Row, Col } from "components/bootstrap";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import AgentWorkflowPageNavigation from "aiagent/AgentWorkflowPageNavigation";
import useModelProviderConfig from "aiagent/hooks/useModelProviderConfig";
import ModelProviderConfigForm from "aiagent/components/ModelProviderConfigForm";
const ModelProviderConfigPage = () => {
  const { data, isLoading } = useModelProviderConfig();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Agent Model Provider" }, /* @__PURE__ */ React.createElement(AgentWorkflowPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "Model Provider" }, /* @__PURE__ */ React.createElement("span", null, "Configure the LLM provider and model used by AI agents.")), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      licenseSubject: LICENSE_SUBJECTS.security,
      title: "Agents are disabled",
      text: "A valid Security license is required to configure agents.",
      bsStyle: "danger",
      displayWarningContainer: true
    },
    /* @__PURE__ */ React.createElement(Row, { className: "content" }, isLoading && /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Spinner, null)), !isLoading && /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(ModelProviderConfigForm, { initialConfig: data })))
  ));
};
export default ModelProviderConfigPage;
